import React from "react";
import { Descriptions,Typography } from "antd";
import { ellipseText } from "../../common/Common";
import { CommonCard } from "./formHelper";
import { checkIncomingDataType } from "./helper";
import _ from "lodash"
import I18n from "../../common/I18n";

const { Text, Paragraph } = Typography;

const CATEGORY_FIELD_MAP = {
  SPLD: [
    { key: "adjustment_category", label: "Adjustment Category" },
    { key: "charge_hours", label: "Charge Hours" },
    {
      key: "include_fuel_surcharge",
      label: "Include fuel surcharge",
      format: (v) => (v === "true" ? "Yes" : "No"),
    },
    { key: "min_hours", label: "Minimum Hours" },
  ],

  BA: [
    { key: "min_charge", label: "Minimum Charge" },
    { key: "max_charge", label: "Maximum Charge" },
  ],

  FSC: [
    { key: "level_of_service", label: I18n.t('general.level_of_service') },
    { key: "los_contract", label: `${I18n.t('general.short_los')} Contract` },
  ],
  EXML: [
    { key: "charge_per_mile", label: "Charge Per Mile" },
    { key: "apply_charges_to", label: "Apply Charges To" },
    {key: "beyond_miles", label: "Beyond Miles"},
    { key: "add_last_zone_value", label: "Add Last Zone Value" },
    { key: "additional_fuel_surcharge", label: "Additional Fuel Surcharge" },
    { key: "fuel_percentage_value", label: "Fuel Percentage Value" },
    { key: "min_charge", label: "Minimum Charge" },
    { key: "max_charge", label: "Maximum Charge" },
  ],
};

const pick = (oldValue, newValue, mode) => {
  if(mode){
    return mode === "previous" ? oldValue : newValue;
  }else{
    return newValue
  }
};


export const adjEntryWithCard = (changes, _, type, mode, category) => {
  if (!changes?.length) return null;

  const oldConfig = changes[0]?.old_value ?? changes[0]?.new_value;
  const newConfig = changes[0]?.new_value ?? changes[0]?.old_value;

  const REQUIRED_KEYS =
    CATEGORY_FIELD_MAP[category]?.map(f => f.key) ?? [];

  const hasAnyRequiredValue = REQUIRED_KEYS.some(
    key => oldConfig?.[key] != null || newConfig?.[key] != null
  );

  if (!hasAnyRequiredValue) return null;

  return (
    <CommonCard minHeight={"120px"} maxHeight={"170px"}>
      {renderBaseRateDetails(oldConfig, newConfig, type, mode, category)}
    </CommonCard>
  );
};



export const adjEntryWithoutCard = (changes, _, type, mode) => {
  if(!changes?.length) return null;
  const oldConfig = changes[0]?.old_value ?? changes[0]?.new_value;
 const newConfig = changes[0]?.new_value ?? changes[0]?.old_value;

  return (
    <>
      {renderAccAdjustmentDetails(oldConfig, newConfig, type, mode)}
    </>
  );
}
 

const renderAccAdjustmentDetails = (oldConfig, newConfig, type = null, mode="") => {
  if (!oldConfig || !newConfig) return null;
  const {
    code: old_code,
    name: old_name,
    category: old_category,
  } = oldConfig || {};

  const {
    code: new_code,
    name: new_name,
    category: new_category,
  } = newConfig || {};

  const getStyle = (oldValue, newValue) => {
    if (oldValue !== newValue) {
      return { backgroundColor: "yellow" };
    }
    return {};
  };

  const renderText = (value) => {
    const displayValue = !["N/A", "n/a", undefined, null, NaN, ""].includes(
      value
    )
      ? value
      : "N/A";

    if (type === "REMOVED") {
      return <Paragraph delete>{ellipseText(String(displayValue).replace(/_/g, " "), 10, true)}</Paragraph>;
    }
    return (
      <Text>{ellipseText(displayValue.replace(/_/g, " "), 10, true)}</Text>
    );
  };

  return (
    <Descriptions
      size="small"
      column={{ xl: 3, lg: 3, md: 3, sm: 2, xs: 2 }}
      style={{ textAlign: "left" }}
    >
      <Descriptions.Item label="Adj Code">
        {mode === "previous" ? (
          renderText(old_code)
        ) : (
          <span style={getStyle(old_code, new_code)}>
            {renderText(new_code)}
          </span>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Adj Name">
        {mode === "previous" ? (
          renderText(old_name)
        ) : (
          <span style={getStyle(old_name, new_name)}>
            {renderText(new_name)}
          </span>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Adj Category">
        {mode === "previous" ? (
          renderText(old_category)
        ) : (
          <span style={getStyle(old_category, new_category)}>
            {renderText(new_category)}
          </span>
        )}
      </Descriptions.Item>
    </Descriptions>
  );
};

const renderBaseRateDetails = (
  oldConfig,
  newConfig,
  type = null,
  mode = "",
  category
) => {
  if (!oldConfig || !newConfig) return null;

  const fields = CATEGORY_FIELD_MAP[category];

  if (!fields?.length) return null;

  const getStyle = (oldValue, newValue) => {
    if (mode === "previous") return {};
    return oldValue !== newValue ? { backgroundColor: "yellow" } : {};
  };

  const renderText = (value) => {
    const displayValue =
      !["N/A", "n/a", undefined, null, NaN, ""].includes(value)
        ? value
        : "N/A";

    if (type === "REMOVED") {
      return (
        <Paragraph delete>
          {ellipseText(String(displayValue).replace(/_/g, " "), 10, true)}
        </Paragraph>
      );
    }

    return (
      <Text>
        {ellipseText(String(displayValue).replace(/_/g, " "), 10, true)}
      </Text>
    );
  };

  const currentScreen = window.location.pathname;
  const renderColSpan = currentScreen.includes("accounts") ? 4 : 3;

  return (
    <Descriptions
      size="small"
      column={{ xl: renderColSpan, lg: renderColSpan, md: 12, sm: 24, xs: 24 }}
      style={{ textAlign: "left" }}
    >
      {fields.map(({ key, label, format }) => {
        const oldVal = oldConfig?.[key];
        const newVal = newConfig?.[key];

        const picked = pick(oldVal, newVal, mode);
        const display = format ? format(picked) : picked;

        return (
          <Descriptions.Item key={key} label={label}>
            <span style={getStyle(oldVal, newVal)}>
              {renderText(display)}
            </span>
          </Descriptions.Item>
        );
      })}
    </Descriptions>
  );
};


export const columnsExtracter = (data=[]) => {
  if(!data.length) return [];
  const dynamicKeys = Object.keys(data[0]);
  return dynamicKeys.map((key) => ({
    title: key.replace(/_/g, " "),
    dataIndex: key,
    key,
     width: 120,
    align: "center",
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  }))
};